import { render, staticRenderFns } from "./AvailableOrderTable.vue?vue&type=template&id=2e0bcc6c&scoped=true"
import script from "./AvailableOrderTable.vue?vue&type=script&lang=ts"
export * from "./AvailableOrderTable.vue?vue&type=script&lang=ts"
import style0 from "./AvailableOrderTable.vue?vue&type=style&index=0&id=2e0bcc6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0bcc6c",
  null
  
)

export default component.exports